"use client";

import { useFormStatus } from "react-dom";
import { login } from "./actions";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, AlertCircle } from "lucide-react";
import Link from "next/link";
import { useTranslations } from "next-intl";

function SubmitButton() {
  const { pending } = useFormStatus();
  const t = useTranslations("login");
  return (
    <Button type="submit" className="w-full h-11 font-medium text-base" disabled={pending}>
      {pending ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          {t("submitting")}
        </>
      ) : (
        t("submit")
      )}
    </Button>
  );
}

export function LoginForm({ error }: { error?: string }) {
  const t = useTranslations("login");
  return (
    <form action={login} className="space-y-4">
      {error && (
        <div className="flex items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/8 px-4 py-3">
          <AlertCircle className="h-4 w-4 text-destructive flex-shrink-0 mt-0.5" />
          <p className="text-sm text-destructive font-medium">
            {error === "invalid_credentials"
              ? t("invalidCredentials")
              : t("genericError")}
          </p>
        </div>
      )}
      <div className="space-y-1.5">
        <Label htmlFor="email" className="text-sm font-medium">
          {t("email")}
        </Label>
        <Input
          id="email"
          name="email"
          type="email"
          placeholder={t("emailPlaceholder")}
          required
          autoComplete="email"
          className="h-10"
        />
      </div>
      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <Label htmlFor="password" className="text-sm font-medium">
            {t("password")}
          </Label>
          <Link
            href="/auth/forgot-password"
            className="text-xs text-primary hover:underline"
          >
            {t("forgotPassword")}
          </Link>
        </div>
        <Input
          id="password"
          name="password"
          type="password"
          required
          autoComplete="current-password"
          className="h-10"
        />
      </div>
      <SubmitButton />
    </form>
  );
}
